<template>
  <Flex direction="column" :reverse="reverse" :justifyContent="y" :alignItems="x">
    <slot />
  </Flex>
</template>

<script setup>
const props = defineProps({
  x: {
    default: 'start'
  },
  y: {
    default: 'start'
  },
  reverse: {
    default: false
  },
})

onBeforeMount(() => {})
</script>

<style lang="scss">
.Column {
}
</style>
